import { useEffect, useState } from 'react';

import { ContentItemBase } from 'pricing/types';
import { pricingContent } from 'pricing/utilities/localStorage/pricingContentStorage';
import { apiContent } from 'utilities/http/api/pricing/apiContent';
import { Nullable } from 'types';

function useBreedColors(breedId: Nullable<number>) {
  const [breedColors, setBreedColors] = useState<ContentItemBase[]>(
    pricingContent.puppyColors,
  );
  const [loading, setLoading] = useState(false);

  const handleSetBreedColors = async () => {
    setLoading(true);
    const resp = await apiContent.getBreedColors(breedId);
    const breedColors = resp?.json?.breedColors || [];
    breedColors.sort((a, b) => a.name.localeCompare(b.name));

    setBreedColors(breedColors);
    setLoading(false);
  };

  useEffect(() => {
    const puppyColors: ContentItemBase[] = pricingContent.puppyColors || [];
    puppyColors.sort((a, b) => a.name.localeCompare(b.name));

    setBreedColors(puppyColors);
    breedId && handleSetBreedColors();
  }, [breedId]);

  return {
    isBreedColorsLoading: loading,
    breedColors,
  };
}

export default useBreedColors;
